export default "__VITE_ASSET__BVQZWDb4__"